"use client";
import { SxProps, Tabs, Theme } from "@mui/material";

export const MUITabs: React.FC<{
  value?: number;
  stringValue?: string;
  onChange?: (event: React.SyntheticEvent, newValue: number) => void;
  onChangeString?: (event: React.SyntheticEvent, newValue: string) => void;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}> = ({ value, onChange, stringValue, onChangeString, children, sx }) => {
  return (
    <Tabs
      value={value || stringValue}
      onChange={onChange || onChangeString}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      id="mui_tabs"
      aria-label="scrollable auto tabs example"
      sx={{
        transitions: "all 0.5s",
        ".MuiTabs-root": {
          boxShadow: "0px 0px 10px 0px #06027377",
          overflow: "hidden",
        },
        ".MuiTabs-flexContainer": {
          borderRadius: "10px",
          gap: "9px",
          transition: "all 0.5s",
          justifyContent: { xs: "left", xl: "center" },
          ".MuiButtonBase-root.MuiTab-root": {
            border: "2px solid #060273",
            textTransform: "initial",
            borderRadius: "25px",
            fontWeight: 700,
            transitions: "all 0.5s",
            color: "primary.main",
            fontFamily: "'blauerNue', 'blauerNue Fallback'",
            fontSize: "15px",
            p: { xs: "5px 18px", md: "2px 11px 0px" },
            "&.Mui-selected": {
              bgcolor: "primary.main",
              color: "#fff",
            },
            "&:hover": {
              bgcolor: "#000",
              color: "#fff",
            },
          },
        },
        ".MuiTabs-indicator": {
          display: "none",
        },
        ".MuiTabs-scrollButtonsHideMobile": {
          display: "flex",
        },
        ".MuiButtonBase-root.MuiTabScrollButton-root.MuiTabs-scrollButtons": {
          bgcolor: "#060273",
          color: "#fff",
          opacity: 1,
          borderRadius: "10px",
          width: "35px",
          transitions: "all 0.5s",
          svg: {
            width: "35px",
            height: "35px",
            p: "2px 0px 0px",
          },
          "&:nth-of-type(1)": {
            borderRadius: "10px 0px 0px 10px",
          },
          "&:nth-of-type(4)": {
            borderRadius: "0px 10px 10px 0px",
          },
          "&.Mui-disabled": {
            opacity: 0,
            width: "0px",
          },
          "&:hover": {
            bgcolor: "#060273",
            color: "#fff",
          },
        },
        ...sx,
      }}
    >
      {children}
    </Tabs>
  );
};
